import React from 'react';

export default function UVP({ data }) {
  return (
    <ul className="uvp">
      {data.map(uvp => {
        return(
          <li key={uvp.id}>
            <div className="uvp-blog">
              <img src={uvp.imageSrc} alt={uvp.value}/>
            <p>{uvp.value}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/Uvp/Uvp.jsx